/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $EventMetricList = {
    properties: {
        eventMetrics: {
    type: 'array',
    contains: {
        type: 'EventMetric',
    },
    isRequired: true,
},
    },
};